import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <main style={{ minHeight: "70vh", display: "grid", placeItems: "center", padding: "40px 20px", textAlign: "center" }}>
      <div><p style={{ letterSpacing: ".18em", color: "#16858a" }}>404 · PAGE NOT FOUND</p><h1>ページが見つかりません</h1><p>URLが変更されたか、ページが削除された可能性があります。</p><Link to="/ocean-guide">Ocean Guideへ戻る</Link></div>
    </main>
  );
}
